import { render, staticRenderFns } from "./withdrawalDetail.vue?vue&type=template&id=2fc23eb4&scoped=true&"
import script from "./withdrawalDetail.vue?vue&type=script&lang=js&"
export * from "./withdrawalDetail.vue?vue&type=script&lang=js&"
import style0 from "./withdrawalDetail.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./withdrawalDetail.vue?vue&type=style&index=1&id=2fc23eb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc23eb4",
  null
  
)

export default component.exports